export default {
  "nav.home": "Strona główna",
  "nav.article": "Przewodnik USFans",
  "nav.categories": "Kategorie",
  "nav.faq": "FAQ",
  "nav.guides": "Przewodniki",
  "nav.shoppingGuide": "Przewodnik zakupowy",
  "nav.openSpreadsheet": "USFans Spreadsheet",

  "lang.label": "Język",

  "cta.exploreSpreadsheet": "Przeglądaj USFans Spreadsheet",
  "cta.buyNow": "Kup teraz",
  "cta.visitMain": "Odwiedź główną stronę",
  "cta.browseGuides": "Przeglądaj przewodniki USFans",
  "cta.readArticle": "Przeczytaj pełny przewodnik",
  "cta.openSpreadsheet": "Otwórz USFans Spreadsheet",
  "cta.backHome": "Wróć na stronę główną",

  "categories.title": "Przeglądaj według kategorii",
  "categories.subtitle": "Przejdź bezpośrednio do kategorii produktów na głównej stronie",
  "categories.selectLabel": "Wybierz kategorię",
  "categories.placeholder": "Wybierz kategorię, aby kontynuować",
  "categories.all": "Wszystkie kategorie",

  "categories.shoes": "Buty",
  "categories.hoodies": "Bluzy/Swetry",
  "categories.tshirts": "Koszulki",
  "categories.jackets": "Kurtki",
  "categories.pants": "Spodnie/Szorty",
  "categories.headwear": "Nakrycia głowy",
  "categories.sets": "Zestawy",
  "categories.underwear": "Bielizna",
  "categories.jersey": "Koszulki sportowe",
  "categories.accessories": "Akcesoria",
  "categories.bags": "Torby",
  "categories.belts": "Paski",
  "categories.perfumes": "Perfumy",
  "categories.other": "Inne rzeczy",

  "footer.tagline": "Niezależne centrum zasobów do przeglądania USFans Spreadsheet i powiązanych przewodników.",
  "footer.disclaimer": "USFansLink.wiki jest niezależnym zasobem informacyjnym i nie musi być powiązany ani wspierany przez USFans.",
  "footer.quickLinks": "Szybkie linki",
  "footer.categories": "Kategorie",
  "footer.resources": "Zasoby",
  "footer.language": "Język",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.about": "O nas",
  "footer.disclaimerLink": "Zastrzeżenie",
  "footer.safety": "Centrum bezpieczeństwa",
};